'use client';

import { Sheet as SheetPrimitive, SheetContent as SheetContentPrimitive, SheetTrigger, SheetTitle, SheetClose } from '@/components/ui/sheet';
import * as React from 'react';
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
interface ExtendedSheetProps extends React.ComponentProps<typeof SheetPrimitive> {
  children: React.ReactNode;
}
interface ExtendedSheetContentProps extends React.ComponentProps<typeof SheetContentPrimitive> {
  hideCloseButton?: boolean;
}
export const Sheet = ({
  children,
  ...props
}: ExtendedSheetProps) => {
  return <SheetPrimitive {...props} data-sentry-element="SheetPrimitive" data-sentry-component="Sheet" data-sentry-source-file="sheet.tsx">{children}</SheetPrimitive>;
};
export const SheetContent = React.forwardRef<React.ElementRef<typeof SheetContentPrimitive>, ExtendedSheetContentProps>(({
  className,
  hideCloseButton = true,
  children,
  ...props
}, ref) => {
  return <SheetContentPrimitive ref={ref} className={cn("h-full w-screen min-w-fit pr-3 scrollbar-none border-none bg-transparent shadow-none [&>button]:hidden", className)} {...props}>
      {!hideCloseButton && <SheetClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary">
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </SheetClose>}
      {children}
    </SheetContentPrimitive>;
});
SheetContent.displayName = 'SheetContent';
export { SheetTrigger, SheetTitle };